import styled from '@emotion/styled';

export const FormWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  background: theme.colors.pageWrapper,
  padding: 10,
}));
